import { jssPreset } from '@material-ui/styles'
import { create } from 'jss'
import jssCompose from 'jss-compose'
import theme from '../slick-ui/build/material/theme'

// Configure JSS
export const jss = create({ plugins: [...jssPreset().plugins, jssCompose()] })

// Initialize the default application theme from Slick-ui
export const overrideTheme = theme